export default __webpack_public_path__ + "static/media/close.8aaab48f.svg";